module.exports = __webpack_public_path__ + "img/bgkV2.a2abdbf4.png";